import { SimpleCustomerSchema } from "./customer-schemas";
import { KeyFigureSchema } from "./key-figure-schema";
import { SimplePlantSchema } from "./plant-schema";
import { ProductPackageSchema } from "./product-package";
import { SimpleUserSchema } from "./user-schemas";

/** How many credits an analysis takes from a Wallet order, and why. */
export interface AnalysisCreditsSchema {
  capacity_mw: number | null;
  mw_credits: number;
  has_soiling: boolean;
  calculated_credits: number;
  credit_usage_override: number | null;
  credits: number;
}

export interface OrderProductPackageSchema {
  id: string;
  order_id: string;
  booked_quantity: number;
  booked_mw?: number;
  product_package: ProductPackageSchema;
  disabled_key_figures_count: number;
  total_analyses_count: number;
  total_analyses_mw?: number;
  analysis_position_within_order_product_package?: number;
  analysis_mw_within_order_product_package?: number;
  /** Only set for Wallet orders: all packages of a Wallet share the credits of the order. */
  booked_credits?: number;
  total_analyses_credits?: number;
  analysis_credits_within_order_product_package?: number;
  analysis_credits?: AnalysisCreditsSchema;
}

export enum OrderType {
  SETUP = 1,
  SUBSCRIPTION = 2,
  MW_SUBSCRIPTION = 3,
  WALLET = 4,
}

export enum PaymentType {
  PRE_PAID = 1,
  INVOICED = 2,
}

export enum PaymentStatus {
  UNPAID = 1,
  PAID = 2,
}

export interface OrderSchema {
  id: string;
  order_type: OrderType;
  technology_id?: number;
  name: string;
  plant?: SimplePlantSchema;
  customer: SimpleCustomerSchema;
  start_date: string;
  end_date: string;
  order_product_packages: OrderProductPackageSchema[];
  created_at: string;
  user_created: SimpleUserSchema;
  updated_at?: string;
  user_updated?: SimpleUserSchema;
  booked_credits?: number;
}

export interface OrderWithZohoSchema extends OrderSchema {
  po_reference?: string;
  po_pdf_link?: string;
  sales_order_number?: string;
  sales_order_zoho_link?: string;
  payment_type: PaymentType;
  payment_status: PaymentStatus;
  notes?: string;
}

export interface OrderPPKeyFiguresDisabledSchema {
  id: string;
  booked_quantity: number;
  product_package_id: number;
  key_figures_disabled: KeyFigureSchema[];
}